<template>
    <div class="user-management">
        <div class="d-flex wrap gap-10">

            <div class="d-flex">
                <label class="mr5">字典名称</label>
                <el-input class="input200" v-model="queryParams.name" :placeholder="`请输入`"
                    clearable></el-input>
            </div>

            <el-button class="ml10" type="primary" size="small" @click="search">{{ `查询`
                }}</el-button>

        </div>

        <div class="page-card">
            <el-table class="mt10" border :data="list">
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column v-for="(item) in headers" :key="item.id" :type="item.type" :label="item.label"
                    :prop="item.prop" :width="item.width">
                    <template slot-scope="scope">
                        <template v-if="item.prop === 'handle'">

                            <el-tooltip effect="dark" v-if="[1,5].includes(user.role_id)" :content="`编辑`" placement="top-start">
                                <el-button class="p0 fontsize20" type="text" @click="openEdit(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                            </el-tooltip>
                            
                            <el-tooltip effect="dark" :content="`字典配置`" placement="top-start">
                                <el-button class="p0 fontsize20" type="text" @click="toDetails(scope.row)"><i class="el-icon-setting"></i></el-button>
                            </el-tooltip>

                        </template>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :queryParams="queryParams" :getList="getList" />
        </div>

        <edit ref="Edit" @fresh="getList" />
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import Pagination from '@/components/common/Pagination';
import Edit from './components/edit.vue';
import {
    sysOptionList,
} from '@/api.js';

import {
    pageSize
} from '@/utils/Config.js';
export default {
    name: 'DictManagement',
    components: {
        Pagination,
        Edit
    },
    computed: {
        ...mapGetters(['user']),
    },
    data() {
        return {
            queryParams: {
                pageIndex: 1,
                pageSize,
                _total: 0,
            },
            headers: [],
            list: [],
        }
    },
    methods: {
        getList() {
            // 获取列表数据
            const url = sysOptionList
            const {
                pageIndex,
                pageSize,
                name,
                type,
                orderBy,
                order
            } = this.queryParams
            const queryParams = {
                page: pageIndex,
                per_page: pageSize,
                name,
                type,
                order_column: orderBy,
                order
            }
            this.$request('get', url, queryParams)
                .then((res) => {
                    console.log(res,'resres');
                    
                    if (res) {
                        this.headers = this.headers.length > 0 ? this.headers : this.$utils.generateColumns(res.columns)
                        this.list = res.data
                        this.queryParams._total = res.total
                    }
                })
        },
        search() {
            this.queryParams.pageIndex = 1
            this.getList()
        },
        openCreate() {
            // 新增
            const {
                Edit
            } = this.$refs

            Edit && Edit.open({
                tenant_text: ''
            })
        },
        openEdit(detail) {
            // 编辑
            const {
                Edit
            } = this.$refs
            const {
                id,
                name,
                remark
            } = detail
            Edit && Edit.open({ id, name, remark })
        },
        openView(detail) {
            // 查看详情
            const {
                Edit
            } = this.$refs
            const {
                id,
                tenant_text
            } = detail

            Edit && Edit.open({ id, isView: true, tenant_text })
        },
        toDetails(row) {
            const url = `${window.location.origin}${this.$utils.siteBase()}basic/dictType/index/${row.type}`

            window.open(url, '_blank')
            
        }
    },
    created() {
        // this.getTenantsOpts()
        this.getList()
    }
}
</script>

<style></style>